"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiAlertDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var KpiAlertDialogDateRange_1 = require("./KpiAlertDialogDateRange");
var alignPoints_1 = require("./alignPoints");
var KpiAlertDialogBrokenFilters_1 = require("./KpiAlertDialogBrokenFilters/KpiAlertDialogBrokenFilters");
var alertThresholdUtils_1 = require("../utils/alertThresholdUtils");
var filterUtils_1 = require("./utils/filterUtils");
var KpiAlertDialogWhenTriggeredPicker_1 = require("./KpiAlertDialogWhenTriggeredPicker");
var DEFAULT_WHEN_TRIGGERED = "aboveThreshold";
var KpiAlertDialogWrapper = function (_a) {
    var children = _a.children;
    var isMobile = sdk_ui_kit_1.useMediaQuery("mobileDevice");
    return children(isMobile);
};
var KpiAlertDialog = /** @class */ (function (_super) {
    tslib_1.__extends(KpiAlertDialog, _super);
    function KpiAlertDialog(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.threshold = react_1.default.createRef();
        _this.saveButton = react_1.default.createRef();
        _this.onCloseClick = function (e) {
            e.stopPropagation();
            _this.closeDialog();
        };
        _this.onCancelClick = function (e) {
            e.stopPropagation();
            _this.closeDialog();
        };
        _this.closeDialog = function () {
            _this.props.onAlertDialogCloseClick();
        };
        _this.onSelect = function (alertType) {
            _this.setState({ alertType: alertType });
        };
        _this.onChange = function (value) {
            _this.setState({ threshold: value });
        };
        _this.saveKpiAlert = function () {
            var whenTriggered = _this.state.alertType;
            var threshold = parseFloat(_this.state.threshold); // convert e.g. valid .2 to 0.2
            threshold = _this.isThresholdRepresentingPercent()
                ? alertThresholdUtils_1.thresholdFromPercentToDecimal(threshold)
                : threshold;
            if (_this.isAlertValid() && !_this.isAlertEmpty()) {
                _this.props.onAlertDialogSaveClick(threshold, whenTriggered);
            }
        };
        _this.deleteKpiAlert = function () {
            _this.props.onAlertDialogDeleteClick();
        };
        _this.applyAlertFilterSetting = function () {
            setTimeout(function () {
                _this.props.onApplyAlertFiltersClick();
            }, 0);
        };
        _this.state = {
            alertType: (_b = (_a = props.alert) === null || _a === void 0 ? void 0 : _a.whenTriggered) !== null && _b !== void 0 ? _b : DEFAULT_WHEN_TRIGGERED,
            threshold: "" + _this.getVisualThreshold(),
        };
        return _this;
    }
    KpiAlertDialog.prototype.componentDidMount = function () {
        this.focusThresholdInput();
    };
    KpiAlertDialog.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isAlertLoading) {
            this.focusThresholdInput();
        }
    };
    KpiAlertDialog.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _a, _b;
        if (this.props.isAlertLoading || !isEqual_1.default(this.props.alert, nextProps.alert)) {
            this.setState({
                alertType: (_b = (_a = nextProps.alert) === null || _a === void 0 ? void 0 : _a.whenTriggered) !== null && _b !== void 0 ? _b : DEFAULT_WHEN_TRIGGERED,
                threshold: "" + this.getVisualThreshold(nextProps),
            });
        }
        if (this.props.isKpiFormatLoading) {
            this.setState({
                threshold: "" + this.getVisualThreshold(nextProps),
            });
        }
    };
    KpiAlertDialog.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(KpiAlertDialogWrapper, null, function (isMobile) {
            return (react_1.default.createElement(sdk_ui_kit_1.Overlay, { alignTo: ".is-alert-dialog.dash-item-content", alignPoints: isMobile ? alignPoints_1.kpiAlertDialogMobileAlignPoints : alignPoints_1.kpiAlertDialogAlignPoints, closeOnOutsideClick: !isMobile, onClose: _this.closeDialog, className: "kpi-alert-dialog-overlay" }, _this.renderDialogBox()));
        }));
    };
    KpiAlertDialog.prototype.formatMessage = function (id, options) {
        return this.props.intl.formatMessage({ id: id }, options);
    };
    KpiAlertDialog.prototype.renderAttributeFiltersInfo = function () {
        var _a;
        var _b = this.props, alert = _b.alert, filters = _b.filters;
        var attributeFilterCount = alert
            ? // for existing alerts, count the stored attribute filters
             (_a = alert.filterContext) === null || _a === void 0 ? void 0 : _a.filters.filter(sdk_backend_spi_1.isDashboardAttributeFilter).length : // otherwise (i.e. when creating a new alert) count attribute filters "from outside"
            filters.filter(sdk_model_1.isAttributeFilter).length;
        if (!attributeFilterCount) {
            return false;
        }
        return (react_1.default.createElement("div", { className: "kpi-alert-dialog-text text-info" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.withAttributeFilters", values: { numFilters: attributeFilterCount } })));
    };
    KpiAlertDialog.prototype.getVisualThreshold = function (props) {
        var _a, _b;
        if (props === void 0) { props = this.props; }
        var threshold = this.isThresholdRepresentingPercent(props)
            ? alertThresholdUtils_1.thresholdFromDecimalToPercent((_a = props.alert) === null || _a === void 0 ? void 0 : _a.threshold)
            : (_b = props.alert) === null || _b === void 0 ? void 0 : _b.threshold;
        return threshold !== null && threshold !== void 0 ? threshold : "";
    };
    KpiAlertDialog.prototype.renderDialogBox = function () {
        return (react_1.default.createElement("div", { className: "kpi-alert-dialog" },
            react_1.default.createElement("div", { className: "action-close gd-icon-cross", onClick: this.onCloseClick }),
            this.renderDialogContent()));
    };
    KpiAlertDialog.prototype.renderDeleteLink = function () {
        if (this.props.alert) {
            var isDeleting = this.props.alertDeletingStatus === "inProgress";
            var deleteButtonTitle = isDeleting
                ? this.formatMessage("kpiAlertDialog.deleting")
                : this.formatMessage("kpiAlertDialog.delete");
            return (react_1.default.createElement(sdk_ui_kit_1.Button, { key: "delete-button", className: "s-delete_button gd-button-link-dimmed delete-link", value: deleteButtonTitle, onClick: this.deleteKpiAlert, disabled: isDeleting }));
        }
        return false;
    };
    KpiAlertDialog.prototype.renderUpdateButton = function () {
        if (this.props.alert) {
            var isUpdating = this.props.alertUpdatingStatus === "inProgress";
            var updateButtonTitle = isUpdating
                ? this.formatMessage("kpiAlertDialog.updatingTitle")
                : this.formatMessage("kpiAlertDialog.updateBrokenTitle");
            return (react_1.default.createElement(sdk_ui_kit_1.Button, { key: "update-button", className: "s-update-button gd-button-action save-button", value: updateButtonTitle, onClick: this.props.onAlertDialogUpdateClick, disabled: isUpdating }));
        }
        return false;
    };
    KpiAlertDialog.prototype.renderBrokenAlert = function () {
        return (react_1.default.createElement("div", { className: "alert-broken" },
            react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "h3" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.brokenAlert" })),
            react_1.default.createElement(KpiAlertDialogBrokenFilters_1.KpiAlertDialogBrokenFilters, { brokenFilters: this.props.brokenAlertFilters }),
            react_1.default.createElement("div", { className: "info" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.brokenAlertAppeal" })),
            this.renderUpdatingErrorMessage(),
            this.renderDeletingErrorMessage(),
            react_1.default.createElement("div", { className: "buttons" },
                this.renderUpdateButton(),
                this.renderDeleteLink())));
    };
    KpiAlertDialog.prototype.renderDialogContent = function () {
        var _a;
        var _b = this.props, isAlertDialogOpening = _b.isAlertDialogOpening, isAlertLoading = _b.isAlertLoading, isKpiFormatLoading = _b.isKpiFormatLoading;
        var threshold = this.state.threshold;
        if (isAlertDialogOpening || isAlertLoading || isKpiFormatLoading) {
            return (react_1.default.createElement("div", { className: "kpi-alert-dialog-content" },
                react_1.default.createElement(sdk_ui_kit_1.Spinner, { className: "gd-dot-spinner-centered" })));
        }
        if ((_a = this.props.brokenAlertFilters) === null || _a === void 0 ? void 0 : _a.length) {
            return react_1.default.createElement("div", { className: "kpi-alert-dialog-content" }, this.renderBrokenAlert());
        }
        var inputSuffix = this.isThresholdRepresentingPercent() ? "%" : "";
        var hasError = !this.isAlertValid() && !this.isAlertEmpty();
        var emailMe = (react_1.default.createElement("span", { className: "underline-dotted", title: this.props.userEmail },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.emailMe" })));
        return (react_1.default.createElement("div", { className: "kpi-alert-dialog-content" },
            react_1.default.createElement("div", { className: "kpi-alert-dialog-text kpi-alert-dialog-text-on-top" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.emailMeWhen", values: { emailMe: emailMe } })),
            react_1.default.createElement(KpiAlertDialogWhenTriggeredPicker_1.KpiAlertDialogWhenTriggeredPicker, { whenTriggered: this.state.alertType, intl: this.props.intl, onWhenTriggeredChange: this.onSelect }),
            react_1.default.createElement("div", { className: "input-container" },
                react_1.default.createElement(sdk_ui_kit_1.Input, { className: "s-threshold-input", hasError: hasError, isSmall: true, maxlength: 16, onChange: this.onChange, onEscKeyPress: this.closeDialog, onEnterKeyPress: this.saveKpiAlert, placeholder: this.props.thresholdPlaceholder, ref: this.threshold, suffix: inputSuffix, value: threshold })),
            this.renderFiltersMessage(),
            this.renderFiltersDifferMessage(),
            this.renderValidationMessage(),
            this.renderSavingErrorMessage(),
            this.renderDeletingErrorMessage(),
            react_1.default.createElement("div", { className: "buttons" },
                react_1.default.createElement(sdk_ui_kit_1.Button, { ref: this.saveButton, className: "gd-button-action save-button s-save_button", value: this.getSaveButtonTitle(), onClick: this.saveKpiAlert, disabled: !this.isSavingEnabled() }),
                react_1.default.createElement(sdk_ui_kit_1.Button, { className: "gd-button-secondary cancel-button s-cancel_button", value: this.formatMessage("cancel"), onClick: this.onCancelClick }),
                this.renderDeleteLink())));
    };
    KpiAlertDialog.prototype.renderDateFilterInfo = function () {
        var _a, _b;
        if (this.props.isDateFilterIgnored) {
            return false;
        }
        var _c = this.props, dateFormat = _c.dateFormat, filters = _c.filters, alert = _c.alert;
        var dateFilters = alert
            ? (_b = (_a = alert.filterContext) === null || _a === void 0 ? void 0 : _a.filters.filter(sdk_backend_spi_1.isDashboardDateFilter)) !== null && _b !== void 0 ? _b : [] : filters.filter(sdk_model_1.isDateFilter);
        var dateFilter = last_1.default(dateFilters);
        return react_1.default.createElement(KpiAlertDialogDateRange_1.KpiAlertDialogDateRange, { filter: dateFilter, dateFormat: dateFormat });
    };
    KpiAlertDialog.prototype.renderFiltersMessage = function () {
        var emailInfo = this.formatMessage("kpiAlertDialog.emailInfo", {
            userEmail: this.props.userEmail,
        });
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "kpi-alert-dialog-text text-info" },
                    this.renderDateFilterInfo(),
                    this.renderAttributeFiltersInfo()),
                react_1.default.createElement("div", { className: "kpi-alert-dialog-text email-info" }, emailInfo))));
    };
    KpiAlertDialog.prototype.renderFiltersDifferMessage = function () {
        var filtersDiffer = !filterUtils_1.areKpiAlertFiltersSameAsDashboard(this.props.alert, this.props.filters);
        var shouldShowFiltersDifferMessage = !!this.props.alert && filtersDiffer;
        return shouldShowFiltersDifferMessage ? (react_1.default.createElement(sdk_ui_kit_1.Message, { type: "warning" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.filtersDiffer" }),
            !!this.props.onApplyAlertFiltersClick && (react_1.default.createElement(react_1.default.Fragment, null,
                " ",
                react_1.default.createElement("a", { className: "s-apply-alert-filters", onClick: this.applyAlertFilterSetting },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.filtersApply" })))))) : (false);
    };
    KpiAlertDialog.prototype.renderValidationMessage = function () {
        if (!this.isAlertValid() && !this.isAlertEmpty()) {
            return (react_1.default.createElement(sdk_ui_kit_1.Message, { type: "error" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.invalidNumber", values: {
                        strong: function (chunks) { return react_1.default.createElement("strong", null, chunks); },
                        br: react_1.default.createElement("br", null),
                    } })));
        }
        return false;
    };
    KpiAlertDialog.prototype.renderSavingErrorMessage = function () {
        if (this.props.alertSavingStatus === "error") {
            return (react_1.default.createElement(sdk_ui_kit_1.Message, { type: "error" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.savingFailed" })));
        }
        return false;
    };
    KpiAlertDialog.prototype.renderUpdatingErrorMessage = function () {
        if (this.props.alertUpdatingStatus === "error") {
            return (react_1.default.createElement(sdk_ui_kit_1.Message, { type: "error" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.updateBrokenFailed" })));
        }
        return false;
    };
    KpiAlertDialog.prototype.renderDeletingErrorMessage = function () {
        if (this.props.alertDeletingStatus === "error") {
            return (react_1.default.createElement(sdk_ui_kit_1.Message, { type: "error" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "kpiAlertDialog.deleteingFailed" })));
        }
        return false;
    };
    KpiAlertDialog.prototype.getSaveButtonTitle = function () {
        return this.props.alertSavingStatus === "inProgress"
            ? this.getUpdatingOrSavingTitle()
            : this.getUpdateOrSetTitle();
    };
    KpiAlertDialog.prototype.getUpdateOrSetTitle = function () {
        return this.props.alert
            ? this.formatMessage("kpiAlertDialog.updateTitle")
            : this.formatMessage("kpiAlertDialog.setTitle");
    };
    KpiAlertDialog.prototype.getUpdatingOrSavingTitle = function () {
        return this.props.alert
            ? this.formatMessage("kpiAlertDialog.updatingTitle")
            : this.formatMessage("kpiAlertDialog.settingTitle");
    };
    KpiAlertDialog.prototype.isThresholdRepresentingPercent = function (props) {
        if (props === void 0) { props = this.props; }
        return props.isThresholdRepresentingPercent;
    };
    KpiAlertDialog.prototype.isSavingEnabled = function () {
        return this.isAlertValid() && !this.isAlertEmpty() && this.props.alertSavingStatus !== "inProgress";
    };
    KpiAlertDialog.prototype.isAlertValid = function () {
        // This is some special function, which works also with strings
        return !isNaN(this.state.threshold); // eslint-disable-line no-restricted-globals
    };
    KpiAlertDialog.prototype.isAlertEmpty = function () {
        return this.state.threshold === undefined || this.state.threshold === "";
    };
    KpiAlertDialog.prototype.focusThresholdInput = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.threshold &&
                _this.threshold.current &&
                _this.threshold.current.inputNodeRef &&
                _this.threshold.current.inputNodeRef.inputNodeRef) {
                var thresholdInputElement = _this.threshold.current.inputNodeRef.inputNodeRef;
                thresholdInputElement.focus();
                thresholdInputElement.select();
            }
        }, 100);
    };
    KpiAlertDialog.defaultProps = {
        isAlertLoading: false,
        isKpiFormatLoading: false,
        thresholdPlaceholder: "",
        isDateFilterIgnored: false,
        isThresholdRepresentingPercent: false,
        filters: [],
        isAlertDialogOpening: false,
        alertDeletingStatus: "idle",
        alertSavingStatus: "idle",
        alertUpdatingStatus: "idle",
    };
    return KpiAlertDialog;
}(react_1.Component));
exports.KpiAlertDialog = KpiAlertDialog;
exports.default = react_intl_1.injectIntl(KpiAlertDialog);
//# sourceMappingURL=KpiAlertDialog.js.map